import "./manholecover.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Manholecover() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740802782/manhole_4_z5yy6w.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740802782/manhole_1_eecghc.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740802782/manhole_2_bs1npp.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740802782/manhole_3_skyj7r.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Manhole Covers || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="We offer production of various styles and sizes of manhole covers to keep pour roads safe and our subsurface facilities"/>
        <meta name="keywords" content="manholecover, gully grating, Lagos Nigeria" />
        </Helmet>
        <h3>Cast Iron Manhole Covers</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Features of Our  Manhole Covers:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Toughness 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Strength
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Ductile
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Fracture Resistance
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Our Manhole Covers are made from cast iron making them durable and long lasting. We offer manhole covers in various shapes and sizes as per customer specification. 

        Manhole covers provide access to underground systems such as sewer lines, stormwater drains, electrical cables, water pipes, and telecom cables. Workers use these openings to inspect, maintain, and repair the systems without disturbing the surface level.

        They are designed to prevent people, vehicles, and animals from falling into manholes, which can be hazardous. They act as protective barriers to ensure safety on roads, sidewalks, and other public spaces.
        </div>
    </div>
  )
}
